import { ensureNamespace } from '@/lib/i18n/runtime'
import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage, type SettingsSearch } from '@/features/settings/components/SettingsPage'
export const Route = createFileRoute('/_auth/settings')({
 // Load route copy together to avoid a shell/settings/profile request waterfall.
 beforeLoad: async ({ search }) => {
  await Promise.all([ensureNamespace('shell'), ensureNamespace('settings'), ...(!search.tab || search.tab === 'profile' ? [ensureNamespace('profile')] : search.tab === 'copilot' ? [ensureNamespace('copilot')] : search.tab === 'custom_fields' ? [ensureNamespace('fields')] : search.tab === 'macros' ? [ensureNamespace('macros')] : search.tab === 'quick_replies' ? [ensureNamespace('replies')] : search.tab === 'tags' ? [ensureNamespace('tags')] : search.tab === 'apps' ? [ensureNamespace('apps')] : search.tab === 'agents' ? [ensureNamespace('agents'), ensureNamespace('roles')] : search.tab === 'roles' ? [ensureNamespace('roles')] : search.tab === 'mcp_connections' ? [ensureNamespace('mcp')] : ['notifications', 'inbox_order'].includes(search.tab) ? [ensureNamespace('preferences')] : [])]).catch(() => {
   // Let the namespace boundaries expose a translated error and retry.
  })
 },
 validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
  tab: typeof search.tab === 'string' ? search.tab : undefined,
  channel: typeof search.channel === 'string' ? search.channel : undefined,
  panel: typeof search.panel === 'string' ? search.panel : undefined,
 }),
 component: SettingsRoute,
})
// eslint-disable-next-line react-refresh/only-export-components
function SettingsRoute() {
 const search = Route.useSearch()
 const navigate = Route.useNavigate()
 return <SettingsPage search={search} onSearchChange={next => { void navigate({ search: next }) }} />
}
